export default "__VITE_PUBLIC_ASSET__af84476c__"